"use client"

import React, { useState } from "react"

const Sparkles = () => (
  <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
    />
  </svg>
)

const OurMissionAndVision = () => {
  const [activeSection, setActiveSection] = useState(null)

  const phrases = ["Deep in belief", "Precise in foundation", "Relentless in execution"]

  return (
    <div className="relative w-full overflow-hidden min-h-screen bg-gradient-to-r from-[#020817] via-[#041E2F] to-black flex items-center justify-center">

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-16 py-16 sm:py-24">

        {/* Header */}
        <div className="text-center mb-16 sm:mb-28">
          <div className="inline-flex items-center gap-2 sm:gap-3 text-blue-400 tracking-[0.2em] uppercase text-xs sm:text-base font-semibold mb-4 sm:mb-6">
            <Sparkles />
            <span>Core Philosophy</span>
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white tracking-tight">
            Future Forward
          </h2>
        </div>

        {/* Sections */}
        <div className="relative flex flex-col md:flex-row items-center md:items-stretch justify-center gap-10 md:gap-16">

          {/* Mission */}
          <div
            className="relative flex-1 group pt-12 sm:pt-20 pb-10 sm:pb-16 px-6 sm:px-10"
            onMouseEnter={() => setActiveSection("mission")}
            onMouseLeave={() => setActiveSection(null)}
          >
            <span className={`absolute top-2 left-2 text-[4rem] sm:text-[6rem] md:text-[8rem] font-bold text-white/[0.04]
              ${activeSection === "mission" ? "text-blue-500/[0.08] scale-105" : ""}
            `}>
              01
            </span>

            <div className={`transition-all duration-300 ${activeSection === "vision" ? "md:opacity-40 md:blur-[1px]" : "opacity-100"}`}>
              <div className="flex items-center gap-4 sm:gap-5 mb-6 sm:mb-10">
                <div className="h-[2px] w-12 sm:w-20 bg-blue-500" />
                <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white">
                  Our Mission
                </h3>
              </div>

       <p className="text-base sm:text-lg md:text-2xl leading-relaxed text-gray-300 max-w-xl">
  To pioneer <strong className="text-white font-semibold">cutting-edge, AI-powered solutions</strong> that empower payers, providers, and regulators, shaping a smarter, more efficient healthcare ecosystem and delivering lasting value for all stakeholders.
</p>


            </div>
          </div>

          {/* Divider (desktop only) */}
          <div className="hidden md:block relative w-[2px] bg-white/10">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 w-[3px] h-32 sm:h-40 bg-gradient-to-b from-blue-400 to-purple-500 rounded-full shadow-[0_0_30px_rgba(59,130,246,.6)] animate-float" />
          </div>

          {/* Vision */}
          <div
            className="relative flex-1 group pt-12 sm:pt-20 pb-10 sm:pb-16 px-6 sm:px-10"
            onMouseEnter={() => setActiveSection("vision")}
            onMouseLeave={() => setActiveSection(null)}
          >
            <span className={`absolute top-2 left-2 text-[4rem] sm:text-[6rem] md:text-[8rem] font-bold text-white/[0.04]
              ${activeSection === "vision" ? "text-purple-500/[0.08] scale-105" : ""}
            `}>
              02
            </span>

            <div className={`transition-all duration-300 ${activeSection === "mission" ? "md:opacity-40 md:blur-[1px]" : "opacity-100"}`}>
              <div className="flex items-center gap-4 sm:gap-5 mb-6 sm:mb-10">
                <div className="h-[2px] w-12 sm:w-20 bg-purple-500" />
                <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white">
                  Our Vision
                </h3>
              </div>
<p className="text-base sm:text-lg md:text-2xl leading-relaxed text-gray-300 max-w-xl">
  To shape a future-ready healthcare ecosystem through <strong className="text-white font-semibold">intelligent, AI-driven innovation</strong>, enabling smarter decisions, greater efficiency, and sustainable impact for all stakeholders.
</p>




            </div>
          </div>

        </div>

        {/* Phrases */}
        <div className="mt-12 sm:mt-16 pt-8 sm:pt-12 border-t border-white/5">
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8">

            {phrases.map((phrase, index) => (
              <React.Fragment key={phrase}>
                <div className="relative px-4 sm:px-8 py-3 sm:py-4 group">
                  <span className="text-sm sm:text-xl md:text-2xl font-semibold text-white/80 tracking-wide transition group-hover:text-white">
                    {phrase}
                  </span>
                  <div className="absolute bottom-1 left-1/2 -translate-x-1/2 w-0 h-[2px] bg-gradient-to-r from-blue-400 to-purple-500 transition-all group-hover:w-3/4 rounded-full" />
                </div>

                {index < phrases.length - 1 && (
                  <div className="hidden sm:block w-[4px] h-10 bg-gradient-to-b from-cyan-300 via-blue-500 to-purple-500 rounded-full animate-pulse" />
                )}
              </React.Fragment>
            ))}

          </div>
        </div>

      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(-20px) translateX(-50%); }
          50% { transform: translateY(20px) translateX(-50%); }
        }
        .animate-float { animation: float 5s ease-in-out infinite; }

        @media (hover: none) {
          .group:hover div { width: 0 !important; }
        }
      `}</style>

    </div>
  )
}

export default OurMissionAndVision
